<template>
  <v-container class="pt-0" fluid>
    <v-row>
      <v-col cols="12">
        <data-registro-data-table :indiceCOGE="indiceCOGE" :loading="loading" @rechargeTable="getIndicesCOGE()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import IndicesCOGE from '@/services/IndicesCOGEService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    name: 'IndicesCOGEHistorico',

    components: {
      DataRegistroDataTable: () => import('@/components/indicesCOGE/DataRegistroDataTable.vue')
    },

    mixins: [tourMixins],
    data() {
      return {
        indiceCOGE: [],
        loading: false,
        arrTour: [
          {
            element: '#btn-nova-importação-indices',
            intro: 'Clicando neste botão você poderá importar novo Índice COGE.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#indices-historico-search',
            intro: 'Neste campo você poderá pesquisar por importações de Índices COGE já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-indices',
            intro: 'Clicando neste ícone você poderá fazer o download em .CSV da importação realizada.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#indices-action-view',
            intro: 'Clicando neste ícone você poderá visualizar os índices COGE importados desse mês.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#indices-action-trash',
            intro: 'Clicando neste ícone você poderá apagar esta importação.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.getIndicesCOGE();
    },

    methods: {
      getIndicesCOGE() {
        this.loading = true;

        IndicesCOGE.getIndicesCOGE()
          .then((response) => {
            this.indiceCOGE = [];
            response.data.dados.forEach((element) => {
              this.indiceCOGE.push({
                dataRegistro: element.DataRegistro ? element.DataRegistro : ' - '
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar dados', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            ((this.loading = false), this.iniciarTourPagina());
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.indiceCOGE.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>
